import { getRootTrail } from '@co4cloud/graph';

export const DEFAULT_APP = 'gi'; // General Information
const APPS = ['gi', 'monitoring', 'thingsboard', 'zev'];

const fixRoute = (route: string) => {
  return route.replace(/\/\//g, '/').replace(/\/$/, '');
};

export const objectsRootPath = '/objects';
export const objectsTrailPath = (trail = ':trail') => `${objectsRootPath}/${trail}`;
export const objectsArgsPath = (app = ':app', trail = ':trail') => `${objectsTrailPath(trail)}/${app}`;
export const objectsArgsSubPath = (app = ':app', trail = ':trail', tab = ':tab?', id = ':id?') =>
  fixRoute(`${objectsArgsPath(app, trail)}/${tab}/${id}`);

//temporary transitioning route for DM2. Remove once app use is stable.
export const objectsDetailsAppPath = `${objectsRootPath}/details/:app?/:trail?/:tab?/:id?`;

// transition route helper
export const transitioningRoute = (params) => {
  // getRootTrail() returns '' when the user has no root objects (CO4-3489);
  // fall back to '0' so the path stays parseable and usePathValidation handles it.
  const rootFallback = getRootTrail() || '0';
  let { app, trail = rootFallback, tab = '', id = '' } = params;

  if (!APPS.includes(app)) {
    const ids = trail?.includes('-') ? trail : rootFallback;
    return objectsArgsSubPath(DEFAULT_APP, ids);
  }

  app = app?.replace(/^:.*/g, DEFAULT_APP);
  trail = trail?.replace(/^:.*/g, rootFallback);
  tab = tab?.replace(/^:.*/g, '');
  id = id?.replace(/^:.*/g, '');

  let path = fixRoute(objectsArgsSubPath(app, trail, tab, id));

  return path;
};
